import { Dayjs } from 'dayjs';
import { WorkTimeType } from 'shared/types';
import { getDateFromWorkTime } from 'utils/datetime/helpers';

type Props = {
	date: Dayjs;
	workTimeAll: WorkTimeType[];
	delay?: number;
};
/**
 * Get previous active day and schedule
 * */
const getPrevActiveBusinessDay = ({ workTimeAll, date, delay }: Props) => {
	const currentWeekDay = date.day();
	let prevActiveDay = date.add(-1, 'day').add(delay ?? 0, 'minute');
	let workTime = workTimeAll.find((w) => w.dayOfWeek === prevActiveDay.day())!;

	if (!workTime?.active) {
		do {
			prevActiveDay = prevActiveDay.add(-1, 'day');
			workTime = workTimeAll.find((w) => w.dayOfWeek === prevActiveDay.day())!;
		} while (!workTime?.active && prevActiveDay.day() !== currentWeekDay);
	}

	const dateWorkTime = getDateFromWorkTime({ workTime, date: prevActiveDay.toDate(), delay });

	return { day: prevActiveDay, workTime, dateWorkTime };
};

export default getPrevActiveBusinessDay;
